// This is a small component that basically loads contentful data
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {Link, BrowserRouter as Router, Route} from "react-router-dom";
import CompPositions from '../comp-positions.jsx';
import {Helmet} from 'react-helmet';
import ModalVideo from 'react-modal-video';
import Fade from 'react-reveal/Fade';

//CONNECTING REDUX STORE -> dynamic content reload across site
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

// SINGLEPOST
import SinglePost from '../singlepost.jsx'

// FETCH ACTION TYPES
import * as pageActions from '../../actions/page-actions.js';

class Pageindex extends Component {
  constructor (props) {
    super(props);
    this.state = {
      isOpen: false
    }
    this.openModal = this.openModal.bind(this)
  }

  openModal () {
    this.setState({isOpen: true})
  }

  //on loading component
  componentWillMount() {
    this.props.actions.fetchPages();
  }

  componentDidMount () {

    var section = document.getElementById("section");

    function calcVH() {
      var vH = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        section.setAttribute("style", "height:" + vH + "px;");
      }

    calcVH();

    window.scrollTo(0, 0)
    var header = document.getElementById("navigation");
    header.classList.remove('active');
    header.style.top = "0";
  }

  componentWillReceiveProps(newProps, props) {
    // store fetched pages into local storage for use later / refresh
    localStorage.setItem("pages", JSON.stringify(newProps.pages));
  }

  renderPosts() {

    if(this.props.pages.items != null) {
      return this.props.pages.items.map((page, i) => {

        const imagex = this.props.pages.includes.Asset.filter(imageTest => imageTest.sys.id == page.fields.image.sys.id);

        return (
          <div key={page.sys.id} className="section">
            <div className="section-image">
              <Link className="image-container" to={`/article/${page.fields.slug}`}><img src={imagex[0].fields.file.url} /><div className="label">{page.fields.name}</div></Link>
            </div>
            <div className="section-content">
              <Link className="read-more" to={`/article/${page.fields.slug}`}><h3>{page.fields.title}</h3></Link>
              <p>{page.fields.description}</p>
              <Link className="read-more" to={`/article/${page.fields.slug}`}><p>Read more</p></Link>
            </div>
          </div>
        );
      });
    }
  }

  render() {
    return (
      <div className="single-page people" id="single-page">
        <Helmet>
          <title>Meet the people</title>
          <link rel="canonical" href={location.protocol + '//' + location.host} />
          <meta property="og:title" content="Meet the people" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={location.href} />
          <meta property="og:image" content={location.protocol + '//' + location.host + '/img/us_single.jpg'} />
        </Helmet>
        <Fade duration={1200} delay={0}>
          <div className="content-wrapper background" id="section">
            <div className="section-content">
              <div className="icon-scroll"></div>
              <h1 className="section-subheading">Meet the people</h1>
              <div className="section-heading">The sum of many</div>
            </div>
          </div>
        </Fade>

        <div className="content-wrapper light">
          <div className="section-content">
            <h2>Meet the people</h2>
            <div className="section-heading">The Bethard</div>
            <div className="section-heading">Experience</div>
          </div>
        </div>

        <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='NczemcW_HSA' onClose={() => this.setState({isOpen: false})} />
        <div className="content-wrapper image margin">
          <img src="/img/bethard-exp-cover.jpg" />
          <a onClick={this.openModal} target="_blank"><img src="/img/video-button.png" className="video-button" /></a>
        </div>

        <div className="content-wrapper dark">
          <div className="post-content">
            <div className="article-heading">The</div>
            <div className="article-heading">People's</div>
            <div className="article-heading-white">stories</div>
            <div className="article-posts">
              {this.renderPosts()}
            </div>
          </div>
        </div>

        <CompPositions/>

      </div>
    );
  }
}

//CONNECT REDUX FETCH APP STATE
function mapStateToProps(state) {
  return {
  pages: state.pages.contentful};
}

//CONNECT REDUX TRIGGER ACTION TO CHANGE APP STATE
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(pageActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Pageindex);



// WEBPACK FOOTER //
// ./client/components/pages/meet-the-people.jsx